"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateAprAndCharge = calculateAprAndCharge;
function calculateAprAndCharge(paymentFrequency, annualPremium, scheduledPremium) {
  var aprRate, apmCharge;
  switch (paymentFrequency) {
    case 'semi-annual':
      aprRate = 2 * (2 * scheduledPremium - annualPremium) / (annualPremium - scheduledPremium);
      apmCharge = 2 * scheduledPremium - annualPremium;
      break;
    case 'quarterly':
      aprRate = 12 * (4 * scheduledPremium - annualPremium) / (5 * annualPremium - 2 * scheduledPremium);
      apmCharge = 4 * scheduledPremium - annualPremium;
      break;
    case 'monthly':
      aprRate = 36 * (12 * scheduledPremium - annualPremium) / (13 * annualPremium + 42 * scheduledPremium);
      apmCharge = 12 * scheduledPremium - annualPremium;
      break;
  }
  return {
    aprRate: (aprRate * 100).toFixed(2),
    apmCharge: apmCharge
  };
}